import { ECategoryErrorType, ECommonDialogType } from '../../data/Constants';
import { openDialog } from '../../store/states/DialogSlice';

/**
 * Shows category-related error dialog with appropriate message
 * @param dispatch - Redux dispatch function
 * @param t - Translation function
 * @param errorType - Type of error to show
 */
export const showCategoryError = (dispatch: any, t: any, errorType: ECategoryErrorType): void => {
  let messageKey: string;

  switch (errorType) {
    case ECategoryErrorType.INVALID_DRAG_DROP:
      messageKey = 'messages.category.inValidCategoryDrag';
      break;
    case ECategoryErrorType.MULTI_NUMERIC_WARNING:
      messageKey = 'messages.category.multiNumericWarning';
      break;
    default:
      messageKey = 'messages.category.genericError';
  }

  dispatch(
    openDialog({
      type: ECommonDialogType.Error,
      data: t(messageKey),
    })
  );
};
